import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for restoring an archived patient. Invalidates the patient and patients list queries on success. */
export function useUnarchivePatient(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await api.delete('/patients/:patientId/archive', { params: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.patient
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', patientId] })
      queryClient.invalidateQueries({ queryKey: ['patients'] })
    },
  })
}
